module.exports = __webpack_public_path__ + "static/media/bg_loser_screen.77384655.png";